import React, { Suspense } from 'react';

import {
  APP_HEADER_NAV_DEFAULT_HEIGHT,
  AppHeaderNavBar,
} from 'components/header-nav/app-header-nav-bar.component';
import { Box, GDSBoxProps, GDSStyleObject } from '@leagueplatform/genesis-core';
import { useScrollTopOnLocationChange } from '@leagueplatform/web-common';
import { ObservabilityErrorBoundary } from '@leagueplatform/observability';
import { ErrorState } from '@premera-web/shared-module';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import { AppFooter } from './app-footer/app-footer.component';

type BasePageProps = GDSBoxProps<'div'> & {
  css?: GDSStyleObject;
  isPrivatePage?: boolean;
};

export const BasePage: React.FC<BasePageProps> = ({
  children,
  isPrivatePage = true,
  css,
  ...boxProps
}) => {
  useScrollTopOnLocationChange();

  const mainContentMinHeight = isPrivatePage
    ? `calc(100vh - ${APP_HEADER_NAV_DEFAULT_HEIGHT}px)`
    : '100vh';

  return (
    <>
      {isPrivatePage && <AppHeaderNavBar />}
      <Box
        as="main"
        id="main-content"
        css={{
          position: 'relative',
          flex: '1',
          minHeight: mainContentMinHeight,
          overflowX: 'hidden',
          ...css,
        }}
        {...boxProps}
      >
        <Suspense fallback={<LoadingIndicator />}>
          <ObservabilityErrorBoundary
            fallback={
              <ErrorState
                headingId="STR_ERROR_STATE_HEADING_GENERIC"
                bodyId="STR_ERROR_STATE_BODY_API"
                buttonId="STR_RELOAD"
                styleProps={{
                  css: {
                    height: mainContentMinHeight,
                  },
                }}
              />
            }
            errorContext={{
              context: {
                Context: { location: 'Base Page ErrorBoundary' },
              },
            }}
          >
            {children}
          </ObservabilityErrorBoundary>
        </Suspense>
      </Box>
      {isPrivatePage && <AppFooter />}
    </>
  );
};
